var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Protocols',{attrs:{"title":_vm.$gettext('Protokoly pro nelineární obsah'),"protocols":_vm.protocols,"protocol-ids":_vm.entity.protocol_order_nonlinear_content,"isEditable":_vm.isEditable},on:{"addProtocol":_vm.onAddProtocol,"removeProtocol":_vm.onRemoveProtocol,"sortProtocols":_vm.onSortProtocols}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f5f9241a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/deviceProfiles/forms/NonLinearProtocols.vue
// module id = URZE
// module chunks = 0